var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',{attrs:{"contain":"","src":_vm.logo,"lazy-src":_vm.logo,"max-height":_vm.height,"max-width":_vm.width,"transition":false,"position":_vm.position}})
}
var staticRenderFns = []

export { render, staticRenderFns }